import React from 'react'
import PropTypes from 'prop-types'
import classnames from 'classnames/bind'

import styles from './TitledListItem.module.scss'

const cx = classnames.bind(styles);

const TitledListItem = function ({
  className = '',
  title = '',
  tag: Tag = 'li',
  titleTag: TitleTag = 'h4',
  grouped = false,
  children,
}) {
  return (
    <Tag className={cx('root', {grouped}, className)}>
      {title && (
        <TitleTag className={cx('title')}>
          {title}
        </TitleTag>
      )}
      <div className={cx('description')}>
        {children}
      </div>
    </Tag>
  )
}

TitledListItem.propTypes = {
  className: PropTypes.string,
  title: PropTypes.string,
  tag: PropTypes.string,
  titleTag: PropTypes.string,
  grouped: PropTypes.bool,
}

export default TitledListItem;
